import { render, staticRenderFns } from "./course_side_content.vue?vue&type=template&id=6bb13469&scoped=true&"
import script from "./course_side_content.vue?vue&type=script&lang=js&"
export * from "./course_side_content.vue?vue&type=script&lang=js&"
import style0 from "./course_side_content.vue?vue&type=style&index=0&id=6bb13469&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb13469",
  null
  
)

export default component.exports